import { SxStyleProp } from 'theme-ui';

export const baseStyle: { [k: string]: SxStyleProp } = {
  mainContainer: {
    padding: ['28px 0px 55px', '55px 0px 135px'],
  },
  mainImage: {
    width: '100%',
    display: ['none', 'block'],
    marginTop: '3px',
    marginBottom: '51px',
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: '1200px !important',
    maxHeight: '614px',
  },
  topShare: {
    marginTop: '39px',
    marginBottom: '56px',

    '& h4': {
      '@media screen and (min-width: 1024px)': {
        fontSize: '18px',
        lineHeight: '26px',
      },
    },

    '& svg': {
      width: '24px'
    },
  },
  innerContainer: {
    paddingX: ['24px', 'unset'],
    variant: 'layout.containerCentered',
  },
  mainText: {
    maxWidth: [null, '941px'],
    width: '100%',
  },
  share: {
    marginTop: '79px',
  },
  resourcesFeaturedDownload: {
    marginTop: ['79px', '117px'],
    marginBottom: '0px',
  },
  moreTitle: {
    maxWidth: ['352px', 'unset'],
    textAlign: 'center',
    marginTop: ['57px', '54px'],
  },
  moreGrid: {
    columnGap: [null, '40px', null, null, null, '60px'],
    rowGap: ['43px'],
    marginTop: ['49px', '78px'],
  },
};
